export default () => ({
	legacy: false,
	availableLocales: ["en", "fr"],
	fallbackLocale: ["en", "fr"],
	fallbackWarn: false,
	missingWarn: false,
	globalInjection: true
});
